package com.checkin.host.ui.legal

import androidx.compose.runtime.Composable
import com.checkin.host.theme.AppColors
import com.checkin.shared.legal.LegalDocument
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*

@Composable
fun LegalDocumentView(document: LegalDocument) {
    P({
        style {
            fontSize(13.px)
            color(AppColors.muted)
            margin(0.px, 0.px, 20.px, 0.px)
        }
    }) {
        Text("Version ${document.version} — mise à jour le ${document.updatedAt}")
    }

    document.sections.forEach { section ->
        H2({
            style {
                fontSize(16.px)
                margin(20.px, 0.px, 8.px, 0.px)
                color(AppColors.text)
            }
        }) {
            Text(section.title)
        }
        section.paragraphs.forEach { paragraph ->
            P({
                style {
                    fontSize(14.px)
                    lineHeight("1.6")
                    color(AppColors.muted)
                    margin(0.px, 0.px, 10.px, 0.px)
                }
            }) {
                Text(paragraph)
            }
        }
    }
}
